import { createAction } from '@reduxjs/toolkit';

const postEasyShipShipmentClearState = createAction('postEasyShipShipmentClearState');

export default postEasyShipShipmentClearState;
